module.exports = __webpack_public_path__ + "static/media/cat-post-2.76f7a1f9.jpg";